import { memo } from 'react'

export default memo(function EditIcon(props: any) {
  return (
    <svg
      width={props.size || '48px'}
      height={props.size || '48px'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9 43.4C22.6 43.5 23.3 43.5 24 43.5C28.5 43.5 32.8 42 36.2 39.2C40.3 36 42.8 31.3 43.4 26.1C44.6 15.4 36.8 5.8 26.1 4.6C21.8 4.2 17.5 5.1 13.8 7.4C13.2 7.7 13.1 8.5 13.4 9.1C13.7 9.7 14.5 9.9 15.1 9.5C18.3 7.5 22 6.6 25.8 7C35.1 8 41.9 16.5 40.9 25.8C40.5 30.3 38.2 34.3 34.7 37.2C31.2 40.1 26.7 41.4 22.2 40.9C17.6 40.5 13.6 38.2 10.7 34.7C7.8 31.2 6.5 26.7 7 22.2C7.3 19.6 8.1 17.2 9.5 15C9.9 14.4 9.7 13.7 9.1 13.3C8.5 12.9 7.8 13.1 7.4 13.7C5.9 16.2 4.9 18.9 4.6 21.9C4 27.1 5.5 32.2 8.8 36.2C12 40.3 16.7 42.8 21.9 43.4ZM18 32.5C18.2 32.7 18.5 32.8 18.8 32.8C19.1 32.8 19.5 32.7 19.7 32.5L34.2 18.1C34.7 17.6 34.7 16.8 34.2 16.3C33.7 15.8 32.9 15.8 32.4 16.3L18.8 29.8L14.3 25.9C13.7 25.4 13 25.5 12.5 26C12 26.6 12.1 27.3 12.6 27.8L18 32.5Z"
        fill={props.color || '#888'}
      ></path>
    </svg>
  )
})
